import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import CustomLink from '../../Components/Navigation/CustomLink/CustomLink';
import NewResource from '../../Containers/Create/NewResource/NewResource';
import classes from './facilitator.css';

class FacilitatorIntro extends Component {
  componentDidMount() {}

  render() {
    return (
      <div className={classes.Container}>
        <div className={classes.Center}>
          <h1 className={classes.Title}>Devenir un animateur</h1>
          <div className={classes.Cards}>
            <div className={classes.CardContainer}>
              <h2 className={classes.FeatureName}>Créer</h2>
              <div className={classes.Card} />
            </div>
            <div className={classes.CardContainer}>
              <h2 className={classes.FeatureName}>Inviter</h2>
              <div className={classes.Card} />
            </div>
            <div className={classes.CardContainer}>
              <h2 className={classes.FeatureName}>Gérer</h2>
              <div className={classes.Card} />
            </div>
          </div>
        </div>
        <div className={classes.Center}>
          <h2 className={classes.FeatureName}>
            Pour commencer, essayez de créer quelque chose
          </h2>
          <div className={classes.Cards}>
            <div className={classes.CardContainer}>
              <div className={classes.CreateTitle}>Activité</div>
              <NewResource resource="activities" intro />
            </div>
            <div className={classes.CardContainer}>
              <div className={classes.CreateTitle}>Salle</div>
              <NewResource resource="rooms" intro />
            </div>

            <div className={classes.CardContainer}>
              <div className={classes.CreateTitle}>Cours</div>
              <NewResource resource="courses" intro />
            </div>
          </div>
          <p className={classes.Tutorial}>
            Quelle est la différence entre une activité et une salle? Pour en
            savoir plus sur le fonctionnement de VMT, essayez l'un de nos{' '}

          </p>
        </div>
      </div>
    );
  }
}

export default FacilitatorIntro;



// WEBPACK FOOTER //
// ./src/Layout/Facilitator/Facilitator.js